var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingsMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.617,
    height: 19.579,
    viewBox: "0 0 17.617 19.579",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-76458987"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3219",
    "data-name": "Rectangle 3219",
    width: 17.617,
    height: 19.579,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_98442",
    "data-name": "Group 98442",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10065",
    "data-name": "Group 10065",
    transform: "translate(0)",
    clipPath: "url(#clip-path-76458987)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13060",
    "data-name": "Path 13060",
    d: "M148.27,170.667a3.263,3.263,0,1,0,3.263,3.263,3.263,3.263,0,0,0-3.263-3.263m0,4.895a1.632,1.632,0,1,1,1.632-1.632,1.632,1.632,0,0,1-1.632,1.632",
    transform: "translate(-139.462 -164.141)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13061",
    "data-name": "Path 13061",
    d: "M16.39,11.34l-.362-.209a7.423,7.423,0,0,0,0-2.684l.362-.209A2.449,2.449,0,1,0,13.943,4l-.363.21a7.324,7.324,0,0,0-2.324-1.34V2.447a2.447,2.447,0,0,0-4.895,0v.419A7.324,7.324,0,0,0,4.037,4.209L3.673,4A2.449,2.449,0,1,0,1.225,8.24l.362.209a7.424,7.424,0,0,0,0,2.684l-.362.209a2.449,2.449,0,1,0,2.447,4.242l.363-.21a7.324,7.324,0,0,0,2.325,1.34v.419a2.447,2.447,0,0,0,4.895,0v-.419a7.323,7.323,0,0,0,2.323-1.343l.365.21a2.449,2.449,0,0,0,2.447-4.242Zm-2.079-3.08a5.75,5.75,0,0,1,0,3.059.816.816,0,0,0,.379.924l.884.511a.816.816,0,1,1-.816,1.414l-.886-.512a.816.816,0,0,0-.991.135,5.7,5.7,0,0,1-2.646,1.53.816.816,0,0,0-.613.791v1.022a.816.816,0,1,1-1.632,0V16.111a.816.816,0,0,0-.613-.791,5.7,5.7,0,0,1-2.645-1.533.816.816,0,0,0-.991-.135l-.884.512a.816.816,0,1,1-.825-1.408l.009-.005.884-.511a.816.816,0,0,0,.379-.924,5.75,5.75,0,0,1,0-3.059.816.816,0,0,0-.379-.921l-.884-.511a.816.816,0,1,1,.816-1.414l.886.512a.816.816,0,0,0,.99-.131A5.7,5.7,0,0,1,7.38,4.263a.816.816,0,0,0,.613-.794V2.447a.816.816,0,0,1,1.632,0V3.469a.816.816,0,0,0,.613.791,5.7,5.7,0,0,1,2.646,1.533.816.816,0,0,0,.991.135l.884-.512a.816.816,0,1,1,.825,1.408l-.009.005-.884.511a.816.816,0,0,0-.378.921Z",
    transform: "translate(0)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsMenuIcon);
export default __webpack_public_path__ + "static/media/settings-menu-icon.711208616b40d823d6c42794ed875113.svg";
export { ForwardRef as ReactComponent };